































import 'reflect-metadata'
import { Vue, Component } from 'vue-property-decorator'
import TxParams from '@/components/Transaction/TxParams.vue'
import { ITransactionParams } from '@/services/transactions'

@Component({
    components: { TxParams },
})
export default class TxParamsDialog extends Vue {
    dialog = false
    notifications = false
    sound = true
    widgets = false

    // simply passes value through to the data request layer above
    emitChange(params: ITransactionParams): void {
        this.$emit('change', params)
        this.dialog = false
    }
}
